import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentpurandar() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Purandar',
        heading: 'Urbania on rent in pune: Urbania On Rent in Purandar',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania On Rent in Purandar for corporate groups, families, tourists, and event travelers planning trips to and from the Purandar region. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for long-distance travel, weekend getaways, corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune to Purandar. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe and stress-free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire in Purandar.',

        top: 'Top Places to Visit in Purandar with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Purandar Fort (Purandhar Killa)",
    "description": "Purandar Fort is the most iconic attraction of the region and holds immense historical significance in Maratha history. It is the birthplace of Chhatrapati Sambhaji Maharaj and played a crucial role during the reign of Chhatrapati Shivaji Maharaj. Located at a high elevation, the fort offers breathtaking panoramic views of the surrounding valleys, villages, and Sahyadri ranges. The trek to the fort passes through scenic trails, ancient gates, bastions, and water tanks, making it a favorite destination for trekkers, history lovers, and photographers."
  },
  {
    "title": "Narayaneshwar Temple",
    "description": "Narayaneshwar Temple is an ancient and spiritually important temple dedicated to Lord Shiva, situated near Purandar. Built in Hemadpanthi architectural style, the temple features stone carvings and a calm, sacred ambiance. Surrounded by greenery and open land, it is a peaceful place for meditation and worship. Devotees often visit during Mahashivratri and Shravan month, making it a key spiritual stop in the Purandar region."
  },
  {
    "title": "Pandeshwar Temple",
    "description": "Pandeshwar Temple is another revered Shiva temple in the Purandar taluka, known for its serene surroundings and traditional rituals. The temple attracts local devotees throughout the year and becomes especially lively during religious festivals. Its simple yet sacred environment offers visitors a glimpse into the deep-rooted spiritual culture of rural Maharashtra."
  },
  {
    "title": "Balaji Temple, Ketkawale",
    "description": "Balaji Temple in Ketkawale is a popular religious site near Purandar, visited by devotees seeking blessings for prosperity and peace. The temple is well-maintained and surrounded by a calm rural landscape, making it ideal for a short spiritual retreat. Families often combine temple visits with nearby village exploration and countryside drives."
  },
  {
    "title": "Sinhagad–Purandar View Points",
    "description": "Several viewpoints around Purandar offer stunning visual connections between Sinhagad, Purandar Fort, and nearby hill ranges. These points are especially beautiful during sunrise, sunset, and monsoon season when clouds roll over the hills. They are ideal for photography, peaceful halts, and enjoying cool breezes with scenic backdrops."
  },
  {
    "title": "Village Trails and Rural Landscapes",
    "description": "Purandar is surrounded by traditional Maharashtrian villages offering authentic rural experiences. Walking through these villages allows visitors to observe farming activities, sugarcane fields, wells, temples, and everyday village life. The slow pace, open skies, and friendly locals make it a refreshing escape from urban life."
  },
  {
    "title": "Seasonal Waterfalls Around Purandar",
    "description": "During the monsoon, several small and seasonal waterfalls appear around the hills and slopes of Purandar. These natural cascades enhance the beauty of the region with lush greenery and flowing streams. They are ideal for short hikes, nature photography, and enjoying the monsoon atmosphere safely."
  },
  {
    "title": "Agricultural Fields and Farm Views",
    "description": "Purandar taluka is known for its fertile agricultural land, with vast fields of sugarcane, vegetables, and grains. Visitors can enjoy scenic drives through farmlands, observe irrigation practices, and experience the agrarian backbone of Maharashtra. These landscapes look especially vibrant during post-monsoon and winter seasons."
  },
  {
    "title": "Trek Routes to Lower Purandar",
    "description": "Apart from the main fort trek, the region offers several lesser-known trekking routes and walking paths around Lower Purandar. These routes are suitable for beginners and nature lovers, offering views of hills, valleys, and open plateaus. The calm environment makes these treks ideal for weekend outdoor activities."
  },
  {
    "title": "Local Fairs and Festivals",
    "description": "Purandar hosts traditional fairs, temple festivals, and village celebrations throughout the year. Events during Ganesh Chaturthi, Shiv Jayanti, and local jatras reflect the cultural richness of the region. Visitors during festival times can experience folk music, processions, local food, and strong community spirit."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Purandar",
      "description": "Urbania on Rent in Purandar offers fully air-conditioned Urbania vehicles for city travel, family outings, corporate trips, and leisure journeys. Well-maintained vehicles and professional chauffeurs provide a safe, comfortable, and convenient travel experience for all passengers."
    },
    {
      "name": "Purandar Urbania Bus Hire",
      "description": "Purandar Urbania Bus Hire provides spacious, air-conditioned buses for group tours, corporate events, and social gatherings. With experienced drivers and comfortable seating, each journey is reliable, safe, and enjoyable."
    },
    {
      "name": "Urbania Rental Service Purandar",
      "description": "Urbania Rental Service Purandar delivers premium Urbania vehicles suitable for family trips, sightseeing, corporate travel, and leisure outings. Experienced chauffeurs ensure convenient, safe, and dependable travel at all times."
    },
    {
      "name": "Urbania AC Bus on Rent Purandar",
      "description": "Urbania AC Bus on Rent Purandar provides fully air-conditioned buses for long-distance travel, group tours, and corporate outings. Spacious interiors and trained chauffeurs ensure comfortable and hassle-free journeys."
    },
    {
      "name": "Corporate Urbania Hire Purandar",
      "description": "Corporate Urbania Hire Purandar offers professional transportation for office trips, employee commutes, and corporate events. Punctual service and trained chauffeurs ensure smooth, reliable, and professional travel solutions."
    },
    {
      "name": "Urbania for Outstation Purandar",
      "description": "Urbania for Outstation Purandar provides safe and comfortable long-distance travel with air-conditioned vehicles. Experienced drivers make trips to nearby cities, tourist spots, and corporate locations convenient and enjoyable."
    },
    {
      "name": "Urbania Airport Transfer Purandar",
      "description": "Urbania Airport Transfer Purandar ensures timely pickups and drops for domestic and international airports. Spacious vehicles with professional chauffeurs provide convenient, safe, and stress-free airport transportation."
    },
    {
      "name": "Luxury Urbania Purandar",
      "description": "Luxury Urbania Purandar offers high-end air-conditioned Urbania vehicles with plush interiors for VIP travel, weddings, and executive trips. Chauffeurs ensure a premium, stylish, and comfortable travel experience."
    },
    {
      "name": "Affordable Urbania Hire Purandar",
      "description": "Affordable Urbania Hire Purandar provides budget-friendly Urbania rental services without compromising on comfort or reliability. Ideal for families, groups, and corporate clients seeking value-for-money travel."
    },
    {
      "name": "Chauffeur Driven Urbania Purandar",
      "description": "Chauffeur Driven Urbania Purandar provides stress-free travel with trained, verified chauffeurs. Fully air-conditioned vehicles guarantee smooth, safe, and enjoyable journeys for all passengers."
    },
    {
      "name": "Urbania for Wedding Events Purandar",
      "description": "Urbania for Wedding Events Purandar provides elegant air-conditioned vehicles for weddings, guest transport, and family travel. Professional chauffeurs ensure timely, stylish, and hassle-free transportation."
    },
    {
      "name": "Urbania for Office Trips Purandar",
      "description": "Urbania for Office Trips Purandar delivers reliable and comfortable transportation for daily office commutes, team outings, and corporate events. Focused on convenience and punctuality for corporate travel needs."
    },
    {
      "name": "Best Urbania Rental Purandar",
      "description": "Best Urbania Rental Purandar provides top-rated Urbania rental services known for reliability, vehicle quality, and customer satisfaction. Ideal for corporate travel, family trips, and group outings requiring premium transportation."
    },
    {
      "name": "Urbania Group Travel Purandar",
      "description": "Urbania Group Travel Purandar offers organized and comfortable transportation for group tours, corporate outings, and social events. Fully air-conditioned buses with professional chauffeurs ensure safe, convenient, and enjoyable group travel."
    },
    {
      "name": "Reliable Urbania Hire Purandar",
      "description": "Reliable Urbania Hire Purandar ensures trustworthy, punctual, and safe Urbania rental services. Air-conditioned vehicles with trained chauffeurs provide convenient, comfortable, and dependable travel for all passengers."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Purandar", "Purandar Urbania Bus Hire"],
    ["Urbania Rental Service Purandar", "Urbania AC Bus on Rent Purandar"],
    ["Corporate Urbania Hire Purandar", "Urbania for Outstation Purandar"],
    ["Urbania Airport Transfer Purandar", "Luxury Urbania Purandar"],
    ["Affordable Urbania Hire Purandar", "Chauffeur Driven Urbania Purandar"],
    ["Urbania for Wedding Events Purandar", "Urbania for Office Trips Purandar"],
    ["Best Urbania Rental Purandar", "Urbania Group Travel Purandar"],
    ["Reliable Urbania Hire Purandar", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Purandar",
        "WhyChoosedescription": "Urbania On Rent in Purandar is perfect for group travel, corporate trips, family outings, wedding guest transport, and outstation journeys, offering comfort and spacious seating."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Purandar provides well-maintained Force Urbania vehicles with modern interiors, air-conditioning, and ample legroom for a smooth and comfortable travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Purandar comes with skilled and courteous drivers familiar with Purandar routes, Pune highways, and nearby areas, ensuring safe and punctual travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Purandar for competitive rates with no hidden charges, making group, corporate, and family travel budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Purandar provides round-the-clock booking assistance and support for inquiries, reservations, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Purandar is available for hourly rentals, full-day bookings, corporate trips, wedding transportation, airport transfers, and customized packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for Urbania On Rent in Purandar are regularly cleaned, sanitized, and serviced to ensure passenger safety and comfort."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Purandar guarantees on-time pickups and dependable service for stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Purandar available for local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Purandar can be booked for city travel, corporate trips, family outings, and long-distance journeys.',
    },
    {
        question: 'How can I book Urbania On Rent in Purandar?',
        answer: 'You can book Urbania On Rent in Purandar via phone, WhatsApp, or online for fast and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania On Rent in Purandar?',
        answer: 'Urbania On Rent in Purandar offers spacious seating, professional drivers, clean vehicles, and transparent pricing for corporate, family, and group travel.',
    },
    {
        question: 'Are drivers experienced?',
        answer: 'Yes, all drivers for Urbania On Rent in Purandar are trained, licensed, and experienced in providing safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Purandar allows flexible pickup and drop locations across Purandar, Pune, and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Purandar available 24x7?',
        answer: 'Yes, Urbania On Rent in Purandar operates 24x7 to meet your travel needs anytime.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania vehicles are regularly cleaned, sanitized, and maintained to ensure passenger safety and comfort.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Purandar accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during trips?',
        answer: 'Yes, dedicated customer support is available throughout your journey for smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania be used for corporate, family, and outstation trips?',
        answer: 'Yes, Urbania On Rent in Purandar is ideal for corporate travel, family outings, airport transfers, and group or outstation journeys.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Deepak Shinde',
        feedback: 'Urbania On Rent in Purandar made our family trip very comfortable and enjoyable. Spacious, clean, and reliable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Kavita Patil',
        feedback: 'We hired Urbania On Rent in Purandar for a corporate outing. Excellent service and professional driver.',
        rating: 5,
    },
    {
        id: 3,
        name: 'Mr. Satish Jadhav',
        feedback: 'Urbania On Rent in Purandar provided smooth and hassle-free travel for our group trip. Highly recommended.',
        rating: 5,
    },
];





















































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Purandar",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-purandar.jpg",
  "description": "Urbania On Rent in Purandar offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Purandar and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-purandar"
  }
};





    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Purandar | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Purandar for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Purandar Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Purandar, Purandar Urbania Bus Hire, Urbania Rental Service Purandar, Urbania AC Bus on Rent Purandar, Corporate Urbania Hire Purandar, Urbania for Outstation Purandar, Urbania Airport Transfer Purandar, Luxury Urbania Purandar, Affordable Urbania Hire Purandar, Chauffeur Driven Urbania Purandar, Urbania for Wedding Events Purandar, Urbania for Office Trips Purandar, Best Urbania Rental Purandar, Urbania Group Travel Purandar, Reliable Urbania Hire Purandar"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/101.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentpurandar;